export default "__VITE_ASSET__CI9f83MB__"